/**
   * Function that checks if the URL parameter contains &marxentCTA=true
   * This parameter added if user scans QR code in the Marxent Modal
   * @return {boolean} returns true if &marxentCTA=true parameter is in the URL
   */

export const urlContainsMarxentCTATrue = () => {
  // Checks if marxent has autostart param after scan of QR code
  const params = 'marxentCTA';
  const urlParams = new URLSearchParams(window.location.search);
  return urlParams.get(params) === 'true';
};

/**
   * Function that checks iOS version of a device
   * @return {boolean} returns true if version is higher than the version argument or default version
   */

export const isIOSVersionSupported = (version = 12) => {
  const iOSVersion = parseFloat((`${(/CPU.*OS ([0-9_]{1,5})|(CPU like).*AppleWebKit.*Mobile/i.exec(navigator.userAgent) || [0, ''])[1]}`)
    .replace('undefined', '3_2')
    .replace('_', '.')
    .replace('_', '')); // 13.2
  return iOSVersion >= version;
};

/**
 * Function that checks Android version of a device
 * @return {boolean} returns true if version is higher than the version argument or default version
 */

export const isAndroidVersionSupported = (version = 8) => {
  const match = navigator.userAgent.match(/Android\s([0-9,.]*)/); // Android 9.0
  const androidVersion = match ? parseFloat(match[1]) : 0;
  return androidVersion >= version;
};

/**
   * Function that checks is the device is iOS
   * @return {boolean} returns true if device is iOS
   */
export const isIOS = () => /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;

/**
   * Function that checks is the device is Android
   * @return {boolean} returns true if device is Android
   */
export const isAndroid = () => /Android/.test(navigator.userAgent);

/**
 * Function that first checks platform and then returns if OS version is higher then specified versions
 * @param {number} androidVersion
 * @param {number} iosVersion
 * @return {boolean} returns true if version is higher than the version argument or default version
 */
export const OSVersionSupported = (androidVersion = 8, iosVersion = 12) => {
  if (isAndroid()) {
    return isAndroidVersionSupported(androidVersion);
  } if (isIOS()) {
    return isIOSVersionSupported(iosVersion);
  }
  return true;
};
